// todo: handle authentication
export default function Funnel() {
  return (
    <div className="mt-2 h-full">
      <iframe src="http://localhost:8501/?embed=true" height="1000" style={{ width: "100%", border: "none" }}></iframe>
    </div>
  );
}
